import { GetDocumentsByProjectId, GetDocumentsByProjectIdToken, GroupedDocumentsResult } from "$src/application/projects/sub/documents/queries/GetDocumentsByProjectId";
import type { DocumentSummary } from "$src/domain/projects/documents/DocumentSummary";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";

interface FetchDocumentsParams {
    queryKey: ['documents', number, number];
}

export async function fetchDocuments( { queryKey } : FetchDocumentsParams): Promise<DocumentSummary[]> {
    const [_, groupStoreId, projectId] = queryKey;
    const query = container.resolve<GetDocumentsByProjectId>(GetDocumentsByProjectIdToken);
    return query.execute(groupStoreId, projectId);
}

export function useDocuments(groupStoreId: number, projectId: number) {
    return useQuery<DocumentSummary[], Error, DocumentSummary[], ['documents', number, number]>(
        ['documents', groupStoreId, projectId], 
        fetchDocuments,
        {
            staleTime: 30000,
            cacheTime: 60000,
        }
    );
}